import { useNotifier } from '@cbgms/base/notifier'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Grid } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useFeature } from '@cbgms/base/feature-flags'
import WholesalerForm, { FormValues } from '../components/Form'
import WholesalerCatalogContainer from '../components/catalog/WholesalerCatalogContainer'
import { useMutateWholesaler } from '../hooks/useMutateWholesaler'
import { useMutateWholesalerService } from '../hooks/useMutateWholesalerService'
import { useGetWholesalerWithServices } from '../hooks/useGetWholesalerWithServices'
import { uploadJSONForm } from '../state/actions'

export const EditWholesaler = () => {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const dispatch = useDispatch()
  const { wholesaleUUID } = useParams<{ wholesaleUUID: string }>()
  const hasJsonUploadFeature = useFeature('carsys-support-wholesaler-json-upload')

  const mutateWholesaler = useMutateWholesaler()
  const mutateWholesalerService = useMutateWholesalerService()

  const { data, isLoading } = useGetWholesalerWithServices(wholesaleUUID)

  const onSubmit = async (values: FormValues) => {
    const { UUID, Country, OrderSystem, ServiceToggles, ServiceConfig, JSONFormFile, JSONFormName } = values

    // Transform ServiceToggles and ServiceConfig form values to API compatible request body
    const services = Object.keys(ServiceToggles).map(key => ({ Service: key, Active: ServiceToggles[key], Config: ServiceConfig[key] }))

    try {
      await mutateWholesaler.mutateAsync({ UUID, wholesaler: values })
      await mutateWholesalerService.mutateAsync({ UUID, country: Country, orderSystem: OrderSystem, services })

      if (hasJsonUploadFeature && JSONFormFile && JSONFormName) {
        await dispatch(uploadJSONForm(UUID, JSONFormFile, JSONFormName))
      }
    } catch (e) {
      notifier.error(t('global.error'))
    }

    return values
  }

  const onSubmitSuccess = () => {
    notifier.success(t('global.successfully_saved'))
  }

  if (isLoading || !data) return null
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <WholesalerForm initialValues={data} onSubmit={onSubmit} onSubmitSuccess={onSubmitSuccess} />
      </Grid>
      <Grid item xs={12}>
        <WholesalerCatalogContainer />
      </Grid>
    </Grid>
  )
}

export default EditWholesaler
